/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.tsx'
import { Route as SecuredRouteImport } from './routes/_secured.tsx'
import { Route as AuthRouteImport } from './routes/_auth.tsx'
import { Route as SecuredIndexRouteImport } from './routes/_secured/index.tsx'
import { Route as SecuredSettingsRouteImport } from './routes/_secured/settings.tsx'
import { Route as SecuredSchedulesRouteImport } from './routes/_secured/schedules.tsx'
import { Route as SecuredImportHubRouteImport } from './routes/_secured/import-hub.tsx'
import { Route as SecuredFilesRouteImport } from './routes/_secured/files.tsx'
import { Route as AuthWorkspacesIndexRouteImport } from './routes/_auth/workspaces/index.tsx'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index.tsx'
import { Route as AuthLoginAuth0IndexRouteImport } from './routes/_auth/login-auth0/index.tsx'
import { Route as SecuredChatChatIdRouteImport } from './routes/_secured/chat.$chatId.tsx'

const SecuredRoute = SecuredRouteImport.update({
  id: '/_secured',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_secured.lazy.tsx').then((d) => d.Route))
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_auth.lazy.tsx').then((d) => d.Route))
const SecuredIndexRoute = SecuredIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/index.lazy.tsx').then((d) => d.Route),
)
const SecuredSettingsRoute = SecuredSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/settings.lazy.tsx').then((d) => d.Route),
)
const SecuredSchedulesRoute = SecuredSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/schedules.lazy.tsx').then((d) => d.Route),
)
const SecuredImportHubRoute = SecuredImportHubRouteImport.update({
  id: '/import-hub',
  path: '/import-hub',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/import-hub.lazy.tsx').then((d) => d.Route),
)
const SecuredFilesRoute = SecuredFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/files.lazy.tsx').then((d) => d.Route),
)
const AuthWorkspacesIndexRoute = AuthWorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/workspaces/index.lazy.tsx').then((d) => d.Route),
)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/login/index.lazy.tsx').then((d) => d.Route),
)
const AuthLoginAuth0IndexRoute = AuthLoginAuth0IndexRouteImport.update({
  id: '/login-auth0/',
  path: '/login-auth0/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/login-auth0/index.lazy.tsx').then((d) => d.Route),
)
const SecuredChatChatIdRoute = SecuredChatChatIdRouteImport.update({
  id: '/chat/$chatId',
  path: '/chat/$chatId',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/chat.$chatId.lazy.tsx').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof SecuredIndexRoute
  '/files': typeof SecuredFilesRoute
  '/import-hub': typeof SecuredImportHubRoute
  '/schedules': typeof SecuredSchedulesRoute
  '/settings': typeof SecuredSettingsRoute
  '/chat/$chatId': typeof SecuredChatChatIdRoute
  '/login-auth0/': typeof AuthLoginAuth0IndexRoute
  '/login/': typeof AuthLoginIndexRoute
  '/workspaces/': typeof AuthWorkspacesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof SecuredIndexRoute
  '/files': typeof SecuredFilesRoute
  '/import-hub': typeof SecuredImportHubRoute
  '/schedules': typeof SecuredSchedulesRoute
  '/settings': typeof SecuredSettingsRoute
  '/chat/$chatId': typeof SecuredChatChatIdRoute
  '/login-auth0': typeof AuthLoginAuth0IndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/workspaces': typeof AuthWorkspacesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_secured': typeof SecuredRouteWithChildren
  '/_secured/files': typeof SecuredFilesRoute
  '/_secured/import-hub': typeof SecuredImportHubRoute
  '/_secured/schedules': typeof SecuredSchedulesRoute
  '/_secured/settings': typeof SecuredSettingsRoute
  '/_secured/': typeof SecuredIndexRoute
  '/_secured/chat/$chatId': typeof SecuredChatChatIdRoute
  '/_auth/login-auth0/': typeof AuthLoginAuth0IndexRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_auth/workspaces/': typeof AuthWorkspacesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/files'
    | '/import-hub'
    | '/schedules'
    | '/settings'
    | '/chat/$chatId'
    | '/login-auth0/'
    | '/login/'
    | '/workspaces/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/files'
    | '/import-hub'
    | '/schedules'
    | '/settings'
    | '/chat/$chatId'
    | '/login-auth0'
    | '/login'
    | '/workspaces'
  id:
    | '__root__'
    | '/_auth'
    | '/_secured'
    | '/_secured/files'
    | '/_secured/import-hub'
    | '/_secured/schedules'
    | '/_secured/settings'
    | '/_secured/'
    | '/_secured/chat/$chatId'
    | '/_auth/login-auth0/'
    | '/_auth/login/'
    | '/_auth/workspaces/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  SecuredRoute: typeof SecuredRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_secured': {
      id: '/_secured'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SecuredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secured/': {
      id: '/_secured/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SecuredIndexRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/settings': {
      id: '/_secured/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SecuredSettingsRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/schedules': {
      id: '/_secured/schedules'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof SecuredSchedulesRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/import-hub': {
      id: '/_secured/import-hub'
      path: '/import-hub'
      fullPath: '/import-hub'
      preLoaderRoute: typeof SecuredImportHubRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/files': {
      id: '/_secured/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof SecuredFilesRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_auth/workspaces/': {
      id: '/_auth/workspaces/'
      path: '/workspaces'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof AuthWorkspacesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-auth0/': {
      id: '/_auth/login-auth0/'
      path: '/login-auth0'
      fullPath: '/login-auth0/'
      preLoaderRoute: typeof AuthLoginAuth0IndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_secured/chat/$chatId': {
      id: '/_secured/chat/$chatId'
      path: '/chat/$chatId'
      fullPath: '/chat/$chatId'
      preLoaderRoute: typeof SecuredChatChatIdRouteImport
      parentRoute: typeof SecuredRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginAuth0IndexRoute: typeof AuthLoginAuth0IndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthWorkspacesIndexRoute: typeof AuthWorkspacesIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginAuth0IndexRoute: AuthLoginAuth0IndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthWorkspacesIndexRoute: AuthWorkspacesIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface SecuredRouteChildren {
  SecuredFilesRoute: typeof SecuredFilesRoute
  SecuredImportHubRoute: typeof SecuredImportHubRoute
  SecuredSchedulesRoute: typeof SecuredSchedulesRoute
  SecuredSettingsRoute: typeof SecuredSettingsRoute
  SecuredIndexRoute: typeof SecuredIndexRoute
  SecuredChatChatIdRoute: typeof SecuredChatChatIdRoute
}

const SecuredRouteChildren: SecuredRouteChildren = {
  SecuredFilesRoute: SecuredFilesRoute,
  SecuredImportHubRoute: SecuredImportHubRoute,
  SecuredSchedulesRoute: SecuredSchedulesRoute,
  SecuredSettingsRoute: SecuredSettingsRoute,
  SecuredIndexRoute: SecuredIndexRoute,
  SecuredChatChatIdRoute: SecuredChatChatIdRoute,
}

const SecuredRouteWithChildren =
  SecuredRoute._addFileChildren(SecuredRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  SecuredRoute: SecuredRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
